<script>

import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { productBrandService } from "../../services";
import { debounce,success_message,error_message } from "../../Helper/helper";

export default {
  components: { Layout, PageHeader, pagination, productBrandService},
    data() {
        const { status,orderBy,sortBy} = this.$route.query;
        return {
            title: this.trans.get('__JSON__.Products'),
            url: null,
            debounce: false,
            items: [],
            checked: true,
            sortBy: sortBy || "id",
            sortDesc: orderBy && orderBy != '' ? true : orderBy,
            loading: true,
            paginations: {},
            limit: 1,
            search: "",
            status: status == undefined ? '1' :status,
            config: config,
            brandCount: "",
            searchData:debounce(()=>{
                if(!this.init){
                    const {status,orderBy,sortBy} = this.$data;
                    this.$router.replace({name: 'product-brand-list', query: {status,orderBy,sortBy}})
                }
                this.getproductBrand();
                this.init = false;
            },500),
            
            fields: [
                { key: "id", label: "#", sortable: true },
                { key: "image", label: "Image", sortable: false,thClass:"dis-event" },
                { key: "name", label: "Brand Name", sortable: true },
                { key: "producer_name", label: "Company Name", sortable: true },
                { key: "status", label: "Status", sortable: false,thClass:"dis-event" },
                { key: "action", label: "Action", sortable: false,thClass:"dis-event" },
            ],
        };
    },
    mounted() {
        this.getproductBrand();
    },
    methods: {
        sortingChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getproductBrand();
        },
        getproductBrand(page) {
            this.loading = true;
            productBrandService
            .getproductBrand({ 
                search: this.search,
                status: this.status,
                sortBy: this.sortBy,
                orderBy: this.sortDesc ? "desc" : "asc",
                page: page && page > 0 ? page : 1,
            })
            .then((response) => {
                this.loading = false;
                this.paginations = response.data.result;
                this.items = response.data.result.data;
                this.brandCount = response.data.result.data.length;
            });
        },
        deleteProductBrand(id){
            if(confirm("Do you really want to delete?")){
                productBrandService.deleteProductBrand({id:id})
                .then(response => {
                    if (response.data.code === 200) {
                        this.getproductBrand();
                        success_message(response.data.message);
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        }
    },
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page" >
                    <div class="page-title-left">
                        <div class="avatar-xs mr-3">
                        <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                            <i class="bx bx-user-circle"></i>
                        </span>
                        </div>
                        <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Product Brands') }}({{brandCount}})</h4>
                    </div>
                    <div class="page-title-right d-flex">
                        <router-link :to="{name: 'product-brand-add'}" class="btn btn-success btn-rounded mr-2 add-btn">
                            <i class="mdi mdi-plus mr-1"></i>
                            {{ trans.get('__JSON__.Add Product Brand') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row list-table-main">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2 offset-sm-8">
                                <div class="form-group">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Status') }} :</label>
                                        <select class="custom-select" v-model="status" @change="searchData()">
                                        <option value="">{{ trans.get('__JSON__.All') }}</option>
                                        <option value="1" selected>{{ trans.get('__JSON__.Active') }}</option>
                                        <option value="0">{{ trans.get('__JSON__.Inactive') }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="date-range-list">
                                    <label>{{ trans.get('__JSON__.Search') }} :</label>
                                    <div class="text-sm-right">
                                        <div class="search-box mr-2 d-inline-block">
                                            <div class="position-relative">
                                                <input
                                                type="text"
                                                class="form-control"
                                                id="search"
                                                @input="searchData()"
                                                v-model="search"
                                                :placeholder="trans.get('__JSON__.Search Placeholder')"
                                                />
                                                <i class="bx bx-search-alt search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 table-main-list customer-table table-responsive">
                                <b-table
                                :items="items"
                                :fields="fields"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                                @sort-changed="sortingChanged"
                                :busy="loading"
                                show-empty
                                >
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>{{trans.get('__JSON__.Loading...')}}</strong>
                                    </div>
                                </template>

                                <template v-slot:cell(id)="data">
                                    <span>{{ data.item.id }}</span>
                                </template>

                                <template v-slot:cell(image)="data">
                                    <div v-if="data.item.image">
                                        <img alt title="image"
                                            class="vendor-img avatar-xs"
                                            :src="config.product_brand+'original/'+data.item.image"
                                            @error="$event.target.src=config.basepath+'no-img.png'"
                                        />   
                                    </div>
                                    <div v-else>
                                        <img class="vendor-img avatar-xs" :src="config.basepath+'no-img.png'" alt />
                                    </div>
                                </template>

                                <template v-slot:cell(name)="data">
                                    <h5 class="font-size-14">{{ data.item.name }}</h5>
                                </template>

                                <template v-slot:cell(producer_name)="data">
                                    <span>{{ data.item.producer_name }}</span>
                                </template>

                                <template v-slot:cell(status)="data">
                                    <div
                                    v-if="data.item.status === '0'"
                                    class="badge badge-pill badge-soft-danger font-size-12"
                                    >{{ trans.get('__JSON__.Inactive') }}</div>
                                    <div
                                    v-else
                                    class="badge badge-pill badge-soft-success font-size-12"
                                    >{{ trans.get('__JSON__.Active') }}</div>
                                </template>

                                <template v-slot:cell(action)="data">
                                    <router-link
                                    :to="{name: 'product-brand-edit',params: { brand_id:base64(data.item.id)}}"
                                    class="btn btn-success btn-sm btn-rounded"
                                    >Edit</router-link>

                                    <button
                                        type="submit"
                                        @click="deleteProductBrand(base64(data.item.id))"
                                        class="btn btn-danger btn-sm btn-rounded ml-1"
                                    >{{ trans.get('__JSON__.Delete') }}</button>
                                </template>

                                <template #empty>
                                    <p class="text-center">{{ trans.get('__JSON__.No Brand') }}</p>
                                </template>
                                </b-table>
                            </div>
                            <div class="row col-sm-5 offset-sm-7">
                                <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                        <pagination
                                            :data="paginations"
                                            :limit="limit"
                                            @pagination-change-page="getproductBrand"
                                        ></pagination>
                                    </ul>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>